import { render, staticRenderFns } from "./HotTagList.vue?vue&type=template&id=43d24830&"
import script from "./HotTagList.vue?vue&type=script&lang=ts&"
export * from "./HotTagList.vue?vue&type=script&lang=ts&"
import style0 from "./HotTagList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports